import * as React from 'react';
import { SVGProps } from 'react';
const BlobIllustration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 412 408"
    fill="none"
    {...props}
  >
    <path d="M392.477 330.817c-31.843 53.46-92.448 66.536-115.305 71.466-77.791 16.784-192.897-3.382-248.432-94.507C-20.002 227.8 7.137 142.382 11.07 130.67c6.595-19.64 23.1-66.747 69.935-98.656C153.9-17.663 265.007-6.526 303.044 44.758c17.858 24.085 3.415 35.19 24.217 77.772 27.856 57.032 62.425 55.664 78.532 101.326 18.185 51.546-10.345 102.019-13.288 106.961" />
  </svg>
);
export default BlobIllustration;
